import React, { useState, useEffect }  from "react";
import { ReactComponent as CoverageIcon } from '../../../../assets/images/coverage-period.svg';
import { ReactComponent as TenYearCoverageIcon } from '../../../../assets/images/Vendor/Rheem/10yrs-coverage-pp.svg';
import { ReactComponent as TenYearCoverageIconMCC } from '../../../../assets/images/Vendor/MCC/Coverage-mcc.svg';
import styles from './PlanOptions.module.css';
import { useContext } from "react";
import { SessionContext } from "../../../../context/SessionContext";
import { getBrandContent } from '../../../BrandingWhiteLabel/BrandContent';

const SelectATerm = () => {  

  const context = useContext(SessionContext);
  const { accountName } = context;
  const currentBrand = getBrandContent(accountName);
  const profile = context.getProfile();
  const [lowerLimit, setlowerLimit] = useState({digit: 0, text: "Zero"});
  const [upperLimit, setUpperLimit] = useState({digit: 10, text: "Ten"});

  const loadWarrantyOptions = () => {
    const accountId = profile?.accountId;
    const masterProgramId = profile?.masterProgramId;

    fetch("pricing/GetMinAndMaxTermsByMasterProgramId/"+masterProgramId+"/hvac").then((res) => {
      if (res.ok) {
        res.json().then((response) => {
          setlowerLimit({
            digit: response?.minTermInYears,
            text: response?.minTermName.split(" ")[0]
          })
          setUpperLimit({
            digit: response?.maxTermInYears,
            text: response?.maxTermName.split(" ")[0]
          });
          
        });
      }
    });
  };

    const getCoverageIcon = (digit) => {
        switch (digit) {
            case 10:
                return <TenYearCoverageIcon className={styles.coverageIcon} />;
            case 12:
                return <CoverageIcon className={styles.coverageIcon} />;
            default:
                return null;
        }
    };

  useEffect(() => {
    loadWarrantyOptions();
  },[]);

  return (
    <>
      {accountName.toLowerCase() === "lennox" || accountName.toLowerCase() === "homedepot" ? (
        <>
          <p>
            Terms range from {lowerLimit.text.toLowerCase()} to {upperLimit.text.toLowerCase()} years from the installation date*.
            Term options will vary depending on the product, {currentBrand.pricingLevelName.toLowerCase()} and plan
            selected.
          </p>
            {getCoverageIcon(upperLimit.digit)}
          <p className="mb-0">
            <span className={styles.note}>*</span> {upperLimit.text} year terms are only
            available for DLSC equipment.
          </p>
        </>
      ) : (
        <>        
          <p>
            Terms range from {lowerLimit.text.toLowerCase()} to {upperLimit.text.toLowerCase()} years from the installation date. 
            Term options will vary depending on the product, {currentBrand.pricingLevelName.toLowerCase()} and plan type.
          </p>
          {(upperLimit.digit === 10 && accountName.toLowerCase() !== "mcc") && 
            <TenYearCoverageIcon className={styles.coverageIcon} />
          }
          {(upperLimit.digit === 10 && accountName.toLowerCase() === "mcc") && 
            <TenYearCoverageIconMCC className={styles.coverageIcon} />
          }
          {upperLimit.digit === 12 && <CoverageIcon className={styles.coverageIcon} />}
        </>
      )}
  </>
  );
}

export default SelectATerm